import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors duration-200">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors duration-200"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}